import { render, staticRenderFns } from "./IframeBlockContainer.vue?vue&type=template&id=408110fe&scoped=true&"
import script from "./IframeBlockContainer.vue?vue&type=script&lang=js&"
export * from "./IframeBlockContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408110fe",
  null
  
)

export default component.exports